import { type ReactNode } from 'react';

import Footer from '@web-platform/global-components-footer';
import FooterFlags from '@web-platform/global-components-footer-flags';
import { logError, logOperationalEvent, logWarn } from 'saddlebag-logger';

import { CookieBanner } from './CookieBanner/CookieBanner';
import { Header } from './Header/Header';

import type { GlobalComponents } from '@web-platform/shared-travel-tools-types/src/global-components';
import type { PageContext } from '@web-platform/shared-travel-tools-types/src/page-context';

type Props = {
  gcs: GlobalComponents;
  isProductionEnv: boolean;
  showHeader?: boolean;
  showFooterFlags?: boolean;
  pageContext: PageContext;
  children: ReactNode;
};

export const PageSkeleton = ({
  children,
  gcs,
  isProductionEnv,
  pageContext,
  showFooterFlags = true,
  showHeader = true,
}: Props) => (
  <>
    {showHeader && gcs.header && (
      <Header
        {...gcs.header.headerProps}
        pageContext={pageContext}
        isProductionEnv={isProductionEnv}
      />
    )}
    {children}
    {gcs.footer && (
      <Footer
        {...gcs.footer}
        isProductionEnv={isProductionEnv}
        logger={{ logError, logOperationalEvent, logWarn }}
      />
    )}
    {showFooterFlags && gcs.footerFlags && (
      <FooterFlags
        {...gcs.footerFlags}
        isProductionEnv={isProductionEnv}
        logger={{ logError, logOperationalEvent, logWarn }}
      />
    )}
    {gcs.cookieBanner && <CookieBanner {...gcs.cookieBanner} isProductionEnv={isProductionEnv} />}
  </>
);
